import * as FateActionTypes from 'actiontypes/fate';

export {
  default as changeAvatar,
  changeAvatarSuccess,
} from './changeAvatar';
export { default as fetch } from './fetch';
export {
  default as purchaseItem,
  purchaseItemSuccess,
} from './purchaseItem';

/** ----------------------------------------------------------------------------
 * PURCHASE DIALOG
 -----------------------------------------------------------------------------*/
export const openPurchaseDialog = item => ({
  type: FateActionTypes.OPEN_PURCHASE_DIALOG,
  item,
  isDialogOpen: true,
});

export const closePurchaseDialog = () => ({
  type: FateActionTypes.CLOSE_PURCHASE_DIALOG,
  isDialogOpen: false,
  hasCompletedInteraction: false,
});

/** ----------------------------------------------------------------------------
 * SELECT AVATAR
 -----------------------------------------------------------------------------*/
export const selectAvatar = avatar => dispatch => dispatch({
  type: FateActionTypes.SELECT_AVATAR,
  avatar,
});

/** ----------------------------------------------------------------------------
 * SELECT AVATAR
 -----------------------------------------------------------------------------*/
export const openFateDialog = (idToOpen, history) => ({
  type: FateActionTypes.OPEN_FATE_DIALOG,
  idToOpen,
});

export const processFateChange = (fateChangeAmount) => ({
  type: FateActionTypes.PROCESS_FATE_CHANGE,
  fateChangeAmount,
});
